<app-dialog title="แก้ไขข้อมูลส่วนตัว">

  <content fxLayout="column">
    <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
      <div fxLayout="column">
        <mat-form-field>
          <input matInput placeholder="คำนำหน้าชื่อ" [(ngModel)]="user.officerPosition" formControlName="position">
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="ชื่อ" [(ngModel)]="user.officerName" formControlName="name">
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="นามสกุล" [(ngModel)]="user.officerSurname" formControlName="surname">
        </mat-form-field>
      </div>
      <footer select="footer" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
        <button mat-button tabindex="2" type="submit" [disabled]="form.invalid">บันทึก</button>
        <button mat-button type="button" (click)="onCancleClick()" tabindex="-1">ยกเลิก</button>
      </footer>
    </form>
  </content>
</app-dialog>
